import { render, staticRenderFns } from "./rongyu.vue?vue&type=template&id=02583d50&scoped=true"
import script from "./rongyu.vue?vue&type=script&lang=js"
export * from "./rongyu.vue?vue&type=script&lang=js"
import style0 from "./rongyu.vue?vue&type=style&index=0&id=02583d50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02583d50",
  null
  
)

export default component.exports